import { BulkPrice, CartridgeServicePackage, Price, Tier } from '@markant-platform/cartridge/model';
import { CurrencyPipe } from '@angular/common';
import { BackofficePrice } from '@markant-platform/shared/backoffice/model';

// basic unit is cents with an accuracy of 4 digits after cents
const DECI_MILLIS = 1_000_000;

/**
 * @deprecated use ServicePackageNamePipe instead
 */
export function getServicePackageName(
  bulkPrice: BulkPrice,
  servicePackages?: CartridgeServicePackage[]
): string | undefined {
  const servicePackage = servicePackages?.find(
    servicePackage => servicePackage.id === bulkPrice.cartridgeServicePackageId
  );

  return servicePackage?.name;
}
/**
 * @deprecated use SortTiersPipe instead
 */
export function sort(tiers: Tier[]): Tier[] {
  return [...tiers].sort((p, n) => {
    return p.minimalNumber + 1 > n.minimalNumber + 1 ? 1 : -1;
  });
}

export function formatPriceWithCurrencyPipe(
  deciMillis: number,
  currency: string,
  currencyPipe: CurrencyPipe
): string | null {
  const price = deciMillis / DECI_MILLIS;
  const format = price % 1 != 0 ? '1.4' : '1.0';
  return currencyPipe.transform(price, currency, 'symbol', format);
}

export function isBulkPrice(price?: Price | BackofficePrice): boolean {
  if (!price?.priceModel) {
    return false;
  }

  return ['PRICE_LEVEL_PER_UNIT', 'PRICE_SCALE_PER_UNIT', 'STAGGERED_FIXED_PRICE'].includes(price.priceModel);
}
